<div
  class="navigation-item"
  [routerLink]="item.route ?? null"
  [class.active]="isActive || showActiveTag"
  [class.expanded]="expanded"
  [class.link]="isLink"
  [class.with-links]="item.links"
  role="button"
  tabindex="0"
  (click)="onClick()"
  (keypress)="$event.key === 'Enter' && onClick()"
>
  <ng-container [ngTemplateOutlet]="navigationItemTemplate" />
</div>
@if (expanded && open) {
  @for (link of item.links; track link.label) {
    <app-side-navigation-item [item]="link" [expanded]="expanded" [isLink]="true" />
  }
}

<ng-template #navigationItemTemplate>
  <span nz-icon [nzType]="item.icon" class="icon"></span>
  @if (showActiveTag) {
    <span class="active-tag"></span>
  }
  @if (expanded) {
    <div class="label-container" [class.with-links]="item.links">
      <span class="label">{{ item.label }}</span>
      @if (item.links) {
        <span nz-icon nzType="icons:navigation/arrow" class="arrow" [class.open]="open"></span>
      }
    </div>
  }
</ng-template>
